<template>
  <v-container style="overflow: hidden auto;">
    <div class="text-h6">Согласие на обработку персональных данных</div>

    <v-divider />

    <div class="d-flex flex-column mt-4">
      <span v-if="!phoneEditMode" class="text-subtitle-1">
        Номер телефона: {{ formatPhone($store.state.meeting.currentMeeting.person_phone) }}
        <v-btn icon plain @click="enableEditMode" title="Изменить номер телефона">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </span>
      <v-text-field
        v-else
        v-model="phone"
        v-mask="'+7(9##) ###-##-##'"
        label="Номер телефона"
        outlined
        type="text"
        hint="Введите другой номер если он не совпадает с текущим"
        autofocus
        dense
        style="max-width: 420px"
      ></v-text-field>

      <div class="my-4">
        <span class="text-caption">Для подтверждения согласия на обработку персональных данных клиенту отправится СМС-код, его будет необходимо ввести ниже.</span>
        <v-btn :disabled="!smsCanBeSend" depressed color="primary" @click="sendSmsCode">
          Отправить СМС-код
        </v-btn>
      </div>

      <v-form style="max-width: 420px" @submit.prevent="verifySmsCode">
        <v-slide-y-transition>
          <v-text-field
            v-if="processId != null"
            v-model="inputSmsCode"
            v-mask="'####'"
            class="align-baseline"
            placeholder="0000"
            type="text"
            outlined
            label="СМС-код"
            dense
            single-line
            :hint="`Код истечёт через ${leftCodeTime} сек.`"
          >
            <template #append-outer>
              <v-btn
                :disabled="inputSmsCode.length !== 4"
                depressed
                color="secondary"
                type="sumbit"
              >
                Подтвердить
              </v-btn>
            </template>
          </v-text-field>
        </v-slide-y-transition>
      </v-form>
    </div>
  </v-container>
</template>

<script>
import { mask } from "vue-the-mask";
import formatPhone from '@/utils/formatPhone';
import { mobileIdSendSms as apiMobileIdSendSms, mobileIdVerifySms as apiMobileIdVerifySms } from '@/api/meeting';

export default {
  directives: {
    mask,
  },

  data: () => ({
    smsCodeExpiredAt: null,
    dateNow: null,
    disableSendCodeButton: false,

    processId: null,
    inputSmsCode: '',

    smsExpireIntervalHandle: null,

    phoneEditMode: false,
    phone: null,
  }),

  computed: {
    currentMeetingId() {
      return this.$store.state.meeting.currentMeetingId;
    },

    leftCodeTime() {
      if (!this.dateNow || !this.smsCodeExpiredAt) return null;
      if (this.dateNow > this.smsCodeExpiredAt) return 0;

      return Math.floor((this.smsCodeExpiredAt - this.dateNow) / 1000);
    },

    smsCanBeSend() {
      const base = this.processId == null && !this.disableSendCodeButton;
      const editMode = !this.phoneEditMode || (this.phoneEditMode && this.phone?.replace(/\D/g, '').length === 11);

      return base && editMode;
    }
  },

  mounted() {
    // без тестов, просто на всякий случай обнуляем (из-за того что компонент может быть уже создан)
    this.disableSendCodeButton = false;
    this.processId = null;
    this.smsCodeExpiredAt = null;
    this.inputSmsCode = '';
    this.phoneEditMode = false;
    this.phone = null;
  },

  deactivated() {
    this.stopSmsExpireInterval();
  },

  beforeDestroy() {
    this.stopSmsExpireInterval();
  },

  methods: {
    formatPhone,

    enableEditMode() {
      this.phone = this.$store.state.meeting.currentMeeting.person_phone;
      this.phoneEditMode = true;
    },

    async sendSmsCode() {
      const response = await apiMobileIdSendSms(this.currentMeetingId, this.phoneEditMode ? this.phone : null);
      if (response) {
        if (response.skip === true) {
          this.disableSendCodeButton = true;

          this.$store.dispatch('meeting/getMeetingById', this.currentMeetingId);
          return;
        }

        let expires_in = response.expires_in ? Number(response.expires_in) : null;
        if (!expires_in || Number.isNaN(expires_in) || expires_in < 0) {
          expires_in = 60; // хоть что-то...
        }

        this.smsCodeExpiredAt = Date.now() + expires_in * 1000 + 1000; // +1000 ms. for safe purpose only
        this.processId = response.processId;

        this.startSmsExpireInterval();
      }
    },

    async verifySmsCode() {
      const response = await apiMobileIdVerifySms(this.currentMeetingId, this.processId, this.inputSmsCode);
      if (response) {
        this.stopSmsExpireInterval();

        this.$store.dispatch('meeting/getMeetingById', this.currentMeetingId);
      }
    },

    startSmsExpireInterval() {
      this.stopSmsExpireInterval();

      this.smsExpireIntervalHandle = setInterval(() => {
        if ((this.leftCodeTime != null && this.leftCodeTime <= 0) || !this.processId) {
          this.processId = null;
          this.stopSmsExpireInterval();
          return;
        }

        this.dateNow = Date.now();
      }, 500);
    },

    stopSmsExpireInterval() {
      if (this.smsExpireIntervalHandle) {
        clearInterval(this.smsExpireIntervalHandle);
        this.smsExpireIntervalHandle = null;
      }
    }
  }
};
</script>
